import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TOrdersApi } from './types';

export const orders: TOrdersApi = {
	getConfirmedOrders: (payload) =>
		http.post(endpoint.orders.LOAD_CONFIRMED_ORDERS, payload).then((response) => response.data),
	getReturnedOrders: (payload) =>
		http.post(endpoint.orders.LOAD_ORDERS_RETURN, payload).then((response) => response.data),
	getOrderDiscounts: (payload) =>
		http.post(endpoint.orders.LOAD_ORDER_DISCOUNTS, payload).then((response) => response.data),
	getOrderDetails: (payload) =>
		http.post(endpoint.orders.ORDER_DETAILS, payload).then((response) => response.data),
	getOrderDetailsCombined: (payload) =>
		http
			.get(endpoint.orders.ORDER_DETAILS_COMBINED(payload.orderId))
			.then((response) => response.data),
	getOrderReturnBreakdown: (payload) =>
		http.post(endpoint.orders.ORDER_RETURN_BREAKDOWN, payload).then((response) => response.data),
	getOrderDiscountBreakdown: (payload) =>
		http.post(endpoint.orders.ORDER_DISCOUNT_BREAKDOWN, payload).then((response) => response.data),
	getOrderReturnItems: (payload) =>
		http.get(endpoint.orders.ORDER_RETURN_ITEMS(payload.orderId)).then((response) => response.data),
	createOrderReturn: (payload) =>
		http.post(endpoint.orders.CREATE_ORDER_RETURN, payload).then((response) => response.data),
	getOrderDiscountItems: (payload) =>
		http
			.get(endpoint.orders.ORDER_DISCOUNT_ITEMS(payload.orderId))
			.then((response) => response.data),
	createOrderDiscount: (payload) =>
		http.post(endpoint.orders.CRATE_ORDER_DISCOUNT, payload).then((response) => response.data),
	getVatAndEASFee: () =>
		http.get(endpoint.orders.LOAD_VAT_AND_EAS_FEE).then((response) => response.data),
	getOrderVatCorrectionsBreakdown: (payload) =>
		http.post(endpoint.orders.ORDER_VAT_CORRECTIONS, payload).then((response) => response.data),
};
